import React from "react";
// import { Row, Col } from "react-bootstrap";
// import ProductCard from "../components/ProductCard";
import 'bootstrap/dist/css/bootstrap.min.css'
// import { productsArray } from "./productStore";
import "./tickets.css";

export default function Tickets() {
  // const [selectedSize, setSelectedSize] = useState('all') 

  // const handleSizeChange = event => {
  //   setSelectedSize(event.target.value)
  // }

  // const filteredProducts = productsArray.filter(
  //   product => selectedSize === 'all' || product.size === selectedSize || product.title === 'Ticket'
  // );

  // const handleClick = () => {
  //   window.location.href = "https://www.simpletix.com/e/2026-indiana-bigfoot-conference-tickets-253645";
  // };

  // SIMPLE TIX --- UNCOMMENT ONCE TICKETS GO ON SALE!!!!!!!!

    // useEffect(() => {
    //   const script = document.createElement("script")
    //   script.src = "https://embed.prod.simpletix.com/assets/widget/embediFrame.js"
    //   script.setAttribute(
    //     "data-url",
    //     "https://embed.prod.simpletix.com/961e047d-8a31-4e13-8d15-9d8996e1b8f9/253645?smtxorigin=12"
    //   )
    //   script.async = true
    //   document.getElementById("simpletixEmbed").appendChild(script)
    // }, [])

  return (
    <section id="tickets">
      <div className="ticket-container">
        <div className="ticket-content">
          <span className="ticket-topper">Tickets</span>
          <h2 className="ticket-title">Purchase Conference Tickets, Merchandise and Meet & Greet Dinner Tickets</h2>
          <h3 className="ticket-sale">TICKETS ON SALE SOON!</h3>
          <h3 className="ticket-website">Watch website for information on Conference activities</h3>
          {/* <h3 className="ticket-description">
          All activites are non-refundable. Click on link to purchase a ticket for the Conference. Once you purhase a ticket for $60, for an additional cost you can add any of the following:
          <p className="disclaim">Please note that you can only purchase an add-on for each ticket purchased (i.e. if you purchase 2 tickets you are allowed 2 Meet & Greet Dinner tickets and/or 2 Bigfoot Research Group tickets.)</p>
          <ul>
            <li><span className="sold-out">SOLD OUT</span>Meet and Greet Dinner (on Friday, September 25th at 7:30PM in the Seasons Valley Room) (space is limited, get yours now) $50 per person. Have dinner and mingle with our Speakers and like-minded people.</li>
            <li><span className="sold-out">SOLD OUT</span> Bigfoot Research Groups (on Saturday, September 26th at 7PM) $25 per person. Limited spots available, so reserve yours now. An IBRO Member will take groups of 8 to 10 to designated areas for night research. Bring a lawn chair and red light. (Please no white flashlights). Rain or shine.</li>
            <li><span className="sold-out">SOLD OUT</span>Merchandise (Conference Shirts are $30)</li>
          </ul>
          </h3> */}
          {/* <p>Fireside Chat tickets are now sold out</p> */}
          {/* <div className="vendor-link-btn">
        <button onClick={handleClick}>
          Buy Tickets Here
        </button>
      </div> */}

          
          {/* SIMPLE TIX --- UNCOMMENT ONCE TICKETS GO ON SALE!!!!!!!!!! */}
          {/* <div>
            <div style={{ width: "100%", textAlign: "left" }}>
              <div id="simpletixEmbed"></div>
              <div
              style={{
                fontFamily: "Helvetica, Ariel",
                fontSize: "12px",
                padding: "10px 0 5px",
                margin: "2px",
                width: "100%",
                textAlign: "left"
              }}
              >
                <a
                style={{ color: "#ADB0B6", textDecoration: "none"}}
                target="_parent"
                href="https://www.simpletix.com/?utm_source=embed&utm_medium=web&utm_campaign=embedwidget&utm_content=footer&a=logo"
                >
                  Powered by SimpleTix
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}